'use client'

import { usePlayerListeners } from 'src/hooks/usePlayerListeners'
import { useSocketManager } from 'src/hooks/useSocketManager'

export function ListenersWrapper() {
  useSocketManager() // Make sure we only connect to one socket
  usePlayerListeners() // Always joins playerChannel

  return null
}
